module.exports = __webpack_public_path__ + "media/audio11.5e08a484.mp3";